import { loadFacebookSdk, loadAppleSdk } from './social-sdks';
import store from '../store';
import router from "../router";
import { pumatracApi } from '../utils/axios-config';

let facebookSdkLoaded = false
let appleSdkLoaded = false

export function initFacebookSdk() {
    if(!facebookSdkLoaded){
        loadFacebookSdk().then(() => {
            facebookSdkLoaded = true;
        });
    }
}

export function initAppleSdk() {
    if(!appleSdkLoaded){
        loadAppleSdk().then(() => {
            appleSdkLoaded = true;
        });
    }
}

export function loginWithFacebook () {
    return new Promise(function (resolve, reject) {
        FB.login(response => {
            if (response.authResponse) {
                FB.api('/me', {fields: 'first_name,last_name,email,location'}, response => {
                    FB.api('/me/picture?width=200&height=200&redirect=false', pictureResponse => {
                        response.picture = pictureResponse;
                        resolve(response);
                    });
                });
            } else {
                reject();
            }
        }, {scope: "public_profile,email,user_location,user_friends"});
    })
}

export function storeUser(user) {
    let data = {...store.state.user, ...user};
    saveUserInSession(data);
    store.commit('setUser', data)
}

export function clearUser() {
    saveUserInSession(null);
    store.commit('setUser', null)
}

function saveUserInSession(user) {
    localStorage.setItem("user", JSON.stringify(user));
}

export function getUserFromSession() {
    let user = localStorage.getItem("user");
    if(user !== undefined && user && user !== 'null') {
        user = JSON.parse(user);
        store.commit('setUser', user);
    }
}

export function maybeSendUserToCompleteRegistration(user = null) {
    if(!user) {
        user = store.state.user;
    }
    // if(!user.name || !user.sex) {
    //     router.push({name: 'RegistrationSteps', params: {step: 2}})
    // } else if (!user.goal || !user.interests || user.interests.length < 2) {
    //     router.push({name: 'RegistrationSteps', params: {step: 3}})
    // } else if (!user.preferences || !user.preferences.workoutInterval || !user.preferences.workoutTimeOfDay || !user.preferences.workoutDuration) {
    //     router.push({name: 'RegistrationSteps', params: {step: 4}})
    // }

    // if(!user.firstName || !user.lastName  || !user.location) {
    //     router.push({name: 'RegistrationSteps', params: {step: 2}})
    // }

    if(!user.name || !user.location) {
        router.push({name: 'RegistrationSteps', params: {step: 2}})
    }
}

export function setupLoginGuard() {
    router.beforeEach((to, from, next) => {
        let loginRequired = false;
        const loggedInOnlyRoutes = [
            'Workouts',
            'WorkoutOverview',
            'WorkoutProgress',
            'Profile',
            'Trainers',
            'Account',
            'FitnessSettings',
        ];
        const publicWorkoutEnabledRoutes = [
            'WorkoutOverview',
            'WorkoutProgress',
        ];
        if(store.getters.user) {

            // redirect user to complete registration
            let user = store.getters.user;
            // if(to.name === 'Login' || (to.name === 'Register' && (to.params.step === undefined || to.params.step === 1))) {
            //     next({name: 'Discover'})
            // } else if(to.name === 'Discover' || to.name === 'Register' || to.name === 'Profile' || to.name === 'RegistrationSteps') {
            //     next();
            // } else if(!user.name || !user.sex) {
            //     next({name: 'RegistrationSteps', params: {step: 2}})
            // } else if (!user.goal || !user.interests || user.interests.length < 2) {
            //     next({name: 'RegistrationSteps', params: {step: 3}})
            // } else if (!user.preferences || !user.preferences.workoutInterval || !user.preferences.workoutTimeOfDay || !user.preferences.workoutDuration) {
            //     next({name: 'RegistrationSteps', params: {step: 4}})
            // } else {
            //     next();
            // }

            if(to.name === 'Login' || (to.name === 'Register' && (to.params.step === undefined || to.params.step === 1))) {
                next({name: 'Discover'})
            } else if(to.name === 'Discover' || to.name === 'Register' || to.name === 'Profile' || to.name === 'RegistrationSteps') {
                next();
            } else if(!user.location || !user.name ) {
                next({name: 'RegistrationSteps', params: {step: 2}})
            } else {
                next();
            }

        } else {

            // block hidden routes
            if(loggedInOnlyRoutes.indexOf(to.name) >= 0) {
                if(publicWorkoutEnabledRoutes.indexOf(to.name) >= 0) {
                    if(store.getters.staticWorkoutIds.indexOf(to.params.id) < 0) {
                        loginRequired = true;
                    }
                } else {
                    loginRequired = true;
                }
            }
            if(loginRequired){
                next({ name: 'Login', params: {redirect: to.path} });
            } else {
                next();
            }
        }
    })
}